/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/button-has-type */
import { FixedSizeList, areEqual } from 'react-window'
import { columnSorting, picDashboard } from 'assets/Icons'
import { Icon } from 'assets/index'
import React, { useState, useRef } from 'react'
import { TableContainer } from './style'

interface IGridProps {
  data: any
  header: string[]
  width?: any
  isFixed?: boolean
  row?: any
  colabInfo?: any
}

interface IGridItem {
  children: any
}

function HeaderItem(props: IGridItem) {
  const { children } = props
  return (
    <button
      type="button"
      onClick={() => console.log('data')}
      className="grid-header"
    >
      <span>{children}</span>
      <img className="btn-next-icon" src={columnSorting} alt="column sorting" />
    </button>
  )
}

export default function DataGridDemo(props: IGridProps) {
  const { data, header, width, isFixed, row, colabInfo } = props
  const [firstItemPage, setFirstItemPage] = useState<number>(0)
  const [page, setPage] = useState<number>(1)
  const listRef = useRef()
  const advanceTablePage = () => {
    if (page === Math.ceil(data.length / 10)) return
    setFirstItemPage((oldValue) => oldValue + 10)
    setPage((oldValue) => oldValue + 1)
  }

  const backTablePage = () => {
    if (page === 1) return
    setFirstItemPage((oldValue) => oldValue - 10)
    setPage((oldValue) => oldValue - 1)
  }

  const counter = (level: number[]) => {
    let count = 0
    level.forEach((permission) => {
      if (permission === 1) count += 1
    })
    return count
  }

  if (!data.length) return null

  return (
    <TableContainer columnNumber={header.length} width={width}>
      {header.map((title) => (
        <HeaderItem>{title}</HeaderItem>
      ))}

      {!isFixed && data.map((item: any) => item || <div>-</div>)}

      {/* {isFixed && (
        <FixedSizeList
          height={window.innerHeight - 235}
          itemCount={data?.length}
          itemSize={72}
          width={'100%'}
          // className="task-list"
          innerRef={listRef}
          itemData={{
            items: data,
            ...colabInfo,
          }}
        >
          {row}
        </FixedSizeList>
      )} */}
      {header.map((_title: any, index: number) => {
        if (index === 0) {
          return (
            <div className="grid-footer border-bottom-left">{`${
              firstItemPage > 0 ? `${firstItemPage + 1}` : '1'
            }-${
              firstItemPage + 10 > data?.length
                ? data?.length
                : firstItemPage + 10
            } de ${data?.length}`}</div>
          )
        }

        if (index === header.length - 1) {
          return (
            <div className="grid-footer border-bottom-right">
              <img
                className="table-chevron"
                src={Icon('chevron_left.svg')}
                alt="back table page"
                onClick={backTablePage}
              />
              <span>{`${page}/${Math.ceil(data.length / 10)}`}</span>
              <img
                className="table-chevron"
                src={Icon('chevron_right.svg')}
                alt="advance table page"
                onClick={advanceTablePage}
              />
            </div>
          )
        }

        if (index === header.length - 2) {
          return <div className="grid-footer">{`Página ${page}`}</div>
        }
        return <div className="grid-footer" />
      })}
    </TableContainer>
  )
}
